export var TITLE = 'Kimi';
export var TEXT_MULTIPLE = 0.7;
export var SPACE_MULTIPLE = 0.25;
export var COLOR_PRIMARY = '#000';